module.exports = __webpack_public_path__ + "img/anal_plug2_37.3637d7d9.png";